import {
  feedbackColorYellowPure,
  feedbackColorRedPure,
  brandColorSecondaryPure
} from '@deskfy/unify-design-tokens/jsvariables'

/* @ngInject */
function StorageAmountCardController ($rootScope, $scope, $translate, $q, ToastService, UdsModalService, AccountManagementService) {
  const getRequestStorageDialogController = () => $q.when(import('../../dialogs/request-storage/request-storage-dialog.controller'))

  $scope.flags = {
    loading: true,
    error: false
  }

  $scope.storage = {
    usedAmount: 0,
    totalAmount: 0,
    totalTextAmount: '',
    availablePercentage: '0%',
    usedPercentage: '0%',
    state: {
      type: 'normal',
      color: brandColorSecondaryPure
    }
  }

  $scope.planName = ''

  const api = {
    getRequestStorageDialogController,
    _getStorageUsage,
    _successGetStorageUsage,
    _errorGetStorageUsage,
    _finallyGetStorageUsage,
    _getPercentage,
    _getStorageState,
    _successGetCompanyFeaturesAndAddons
  }

  this.getApi = () => api

  activate()

  function activate () {
    $rootScope.getUser().then(api._getStorageUsage)
    $rootScope.getCompanyFeaturesAndAddons().then(api._successGetCompanyFeaturesAndAddons)
  }

  $scope.openRequestQuoteStorage = function () {
    api.getRequestStorageDialogController().then(({ RequestStorageDialogController }) => {
      const requestStorageDialog = UdsModalService.createModal({
        controller: RequestStorageDialogController,
        modalName: 'requestStorageDialog',
        data: {
          planName: $scope.planName
        }
      })

      requestStorageDialog.open()
    })
  }

  function _getStorageUsage ({ customerCompanyId }) {
    $scope.flags.error = false

    AccountManagementService.getStorageUsage(customerCompanyId, { refreshCache: true })
      .then(api._successGetStorageUsage)
      .catch(api._errorGetStorageUsage)
      .finally(api._finallyGetStorageUsage)
  }

  function _successGetStorageUsage ({ used = 0, total = 0 }) {
    const usedAmount = Math.floor(used)
    const totalAmount = total

    const { availablePercentage, usedPercentage, usedPercentageInNumber } = api._getPercentage(usedAmount, totalAmount)

    const {
      state
    } = api._getStorageState(usedPercentageInNumber)

    $scope.storage = {
      usedAmount,
      totalAmount,
      totalTextAmount: $translate.instant('usageTrackingTotalUsedAmount', { totalAmount }),
      availablePercentage,
      usedPercentage,
      state
    }
  }

  function _errorGetStorageUsage (error) {
    $scope.flags.error = true
    ToastService.defaultErrorToast()
    console.error({ error })
  }

  function _finallyGetStorageUsage () {
    $scope.flags.loading = false
  }

  function _getPercentage (used = 0, total = 0) {
    const multiplier = 100
    const defaultMinAvailable = '0%'
    const defaultMaxUsed = '100%'

    const minPercentage = 0
    const maxPercentage = 100

    const availableRest = Math.floor(total - used)
    const availableCalc = Math.floor((availableRest / total) * multiplier)

    const usedCalc = Math.floor((used / total) * multiplier)

    const availablePercentage = availableCalc < minPercentage ? defaultMinAvailable : `${availableCalc}%`
    const usedPercentage = usedCalc > maxPercentage ? defaultMaxUsed : `${usedCalc}%`

    return {
      availablePercentage,
      usedPercentage,
      usedPercentageInNumber: usedCalc
    }
  }

  function _getStorageState (usedPercentage) {
    if (usedPercentage >= 90) {
      return {
        state: {
          type: 'critical',
          color: feedbackColorRedPure
        }
      }
    }

    if (usedPercentage >= 70) {
      return {
        state: {
          type: 'alert',
          color: feedbackColorYellowPure
        }
      }
    }

    return {
      state: {
        type: 'normal',
        color: brandColorSecondaryPure
      }
    }
  }

  function _successGetCompanyFeaturesAndAddons ({ name }) {
    $scope.planName = name
  }
}

export { StorageAmountCardController }
